import { render, staticRenderFns } from "./CustomBarChartQuizType.vue?vue&type=template&id=1488a951&scoped=true&"
import script from "./CustomBarChartQuizType.vue?vue&type=script&lang=js&"
export * from "./CustomBarChartQuizType.vue?vue&type=script&lang=js&"
import style0 from "./CustomBarChartQuizType.vue?vue&type=style&index=0&id=1488a951&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1488a951",
  null
  
)

export default component.exports